import React, { Component } from 'react'
import {db} from '../../config/fbConfig'
import Imageslider from './Imageslider'
import { Helmet } from 'react-helmet'
import './Blogdes.css'

class Blogdes extends Component {
    state={
        blogs:''
    }

    componentDidMount(){
        db.collection('blogs')
        .get()
        .then(snapshot => {
            const blogs = []
            snapshot.forEach(doc=>{
                const data = doc.data()
                blogs.push(data)
            })
            this.setState({blogs :blogs})
        })
        .catch(err =>{
            console.log(err)
        })
    }
    render() {
        return(
            <div>
            {
                this.state.blogs && this.state.blogs.map(blog=>{
                    if(blog.id===this.props.match.params.id){
                        return (
                            <>
                            <Helmet>
                                <title>{blog.title}</title>
                            </Helmet>
                            <Imageslider photos={blog.albumPhotos} key={blog.id}/>
                            <div className='content-wrapper'>
                            <div className='content-container'>
                                <h1>{blog.title}</h1>
                                {
                                    blog.content.map(cont=>{
                                        return <p>{cont}</p>
                                    })
                                }
                            </div>
                            </div>
                            </>
                        )
                    }
                })
            }
            </div>
        )
        
    }
}

export default Blogdes
